import {
  ATBeaconButton,
  ATBeaconLoadingSpinner,
} from 'components/common/beacon/beaconRegistration';
import { IMRBeaconSVGProps } from 'components/common/icons/icons.types';
import React from 'react';
import { CTAVariant } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';
import './StepFooter.scss';

interface FooterProps {
  footerButtons: FooterButtonConfig[] | undefined;
  isLoading?: boolean;
}

export interface FooterButtonConfig {
  label: string;
  handler: () => void;
  slot: FooterSlot;
  variant: CTAVariant;
  enabled?: boolean;
  icon?: React.FC<IMRBeaconSVGProps>;
}

export enum FooterSlot {
  Left = 'left',
  Right = 'right',
}

export interface FooterActionsConfig {
  actions: FooterButtonConfig[];
}

export const StepFooter: React.FC<FooterProps> = ({ footerButtons, isLoading }) => {
  if (footerButtons == null) return null;

  return (
    <div className="footer">
      <div className="footer-left">
        {footerButtons
          .filter((a) => a.slot === FooterSlot.Left)
          .map((config, index) => (
            <ATBeaconButton
              className={'button-' + config.label}
              key={'button-left-' + index}
              variant={config.variant}
              onClick={config.handler}
              disabled={config.enabled === undefined ? false : !config.enabled}
              slot={config.slot}
            >
              {config.icon && <config.icon slot="prefix" />}
              {config.label}
            </ATBeaconButton>
          ))}
      </div>
      <div className="footer-right">
        {isLoading ? (
          <div className="loading-icon" data-testid="loading-icon">
            <ATBeaconLoadingSpinner scale={'mini'} />
          </div>
        ) : (
          footerButtons
            .filter((a) => a.slot === FooterSlot.Right)
            .map((config, index) => (
              <ATBeaconButton
                className={'button-' + config.label}
                key={'button-right-' + index}
                variant={config.variant}
                onClick={config.handler}
                disabled={config.enabled === undefined ? false : !config.enabled}
                slot={config.slot}
              >
                {config.icon && <config.icon slot="prefix" />}
                {config.label}
              </ATBeaconButton>
            ))
        )}
      </div>
    </div>
  );
};
